import angular from 'angular';
import { StatusProcessoEnum } from '../../enums/statusprocesso';

export class MeurhAdmissoesDadoscontatoFormController implements ng.IController {

    static $inject = [];

    public entity: any;
    public form: angular.IFormController;

    public statusProcessoEnum = StatusProcessoEnum;

    constructor() {/**/}

    preenchePix(): void {
        if (this.entity.tiporecebimentosalario === '256') { // email
            this.entity.chavepix = this.entity.email;
        } else if (this.entity.tiporecebimentosalario === '512' && this.valorExiste(this.entity.dddcel) && this.valorExiste(this.entity.celular)) { // celular
            this.entity.chavepix = this.entity.dddcel + this.entity.celular;
        }
    }

    valorExiste(valor: any): boolean {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }
}
